import { String, Number, Array, Boolean, Object, Optional, Static } from '@sinclair/typebox';

import { FareRules } from '../sas-domain/fareRules';

import { Association } from './association';
import { Fare } from './fare';
import { Price } from './price';

export type Cabin = Static<typeof Cabin>;
export const Cabin = Object({
  selectorId: String(),
  productId: String(),
  cabin: String(),
  productName: String(),
  productCode: String(),
  fareKey: String(),
  price: Price,
  lowestFare: Boolean(),
  isStandardAward: Optional(Boolean()),
  fares: Array(Fare),
  associations: Optional(Array(Association)),
  availableSeats: Optional(Number()),
  /** @deprecated use the fareRules map on "root" instead */
  fareRules: Optional(FareRules),
});
